export enum VARIANT {
    TEXT = 'text',
    CONTAINED = 'contained',
    OUTLINED = 'outlined'
}